<!--
 * @Author: Nie Wie
 * @Date: 2020-03-25 11:10:30
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-30 14:45:10
 * @Description: 观测时报
 -->

<template>
  <div>
    <data-card class="observe-module"></data-card>
    <week-img class="observe-module"></week-img>
    <satellite class="observe-module"></satellite>
    <data-trend class="observe-module"></data-trend>
    <cover-statistics class="observe-module"></cover-statistics>
  </div>
</template>

<script>
import DataCard from './data-card'
import WeekImg from './week-img'
import Satellite from './satellite'
import DataTrend from './data-trend'
import CoverStatistics from './cover-statistics'

export default {
  components: {
    DataCard,
    WeekImg,
    Satellite,
    DataTrend,
    CoverStatistics,
  },
}
</script>

<style>
.observe-module {
  margin-bottom: 50px;
}
</style>
